import React, { useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { MdPlaylistAdd } from 'react-icons/md';
import { FaTimes } from 'react-icons/fa';

import './FinancialForm.css';

export default function FinancialForm(props) {

  const { grants, scholarships, loans } = props.data

  useEffect(() => {
    //Component mounted
    if (!Array.isArray(grants) || grants.length === 0) addRow('grants', [], [["Federal Pell Grant", 0, "Both"], ["Federal SEOG Grant", 0, "Both"], ["ISU Grant", 0, "Both"], ["Teach Grant", 0, "Both"]])
    if (!Array.isArray(scholarships) || scholarships.length === 0) addRow('scholarships', [])
    if (!Array.isArray(loans) || loans.length === 0) addRow('loans', [], [["Federal Direct Subsidized", 0, "Both"], ["Federal Direct Unsubsidized", 0, "Both"], ["Federal Direct PLUS", 0, "Both"]])


    return () => {
      //Component unmounted
    }
  }) // Empty dependency array to run the effect

  const setSection = (key, section) => {
    let ans = { ...props.data }
    if (Array.isArray(section)) {
      ans[key] = section
      props.changeState(ans)
    }
  }
  const addRow = (key, section, names = undefined) => {
    let ans = [...section]
    if (names) {
      names.forEach((i) => ans.push({ name: i[0], amount: i[1], semester: i[2] },))
    }
    else {
      ans.push({ name: "", amount: 0, semester: "Both" },)
    }
    setSection(key, ans)
  }
  const delRow = (i, key, section) => {
    let ans = [...section]
    ans.splice(i, 1)
    setSection(key, ans)
  }
  const changeRow = (i, attr, attr_type, value, key, section) => {
    if (attr_type(value)) {
      let ans = [...section]
      ans[i][attr] = value
      setSection(key, ans)
    }
  }
  const financialTable = (name, section) => {
    return (
      <div className="table">
        <h5>
          {name.toUpperCase()}
          <MdPlaylistAdd style={{ float: "right" }} size={30} onClick={() => addRow(name, section)} />
        </h5>

        {(Array.isArray(section)) &&
          section.map((field, i) => (
            <div key={i} className="field">
              <div className="name my-2">
                {(name === "grants" && i < 4) || (name === "loans" && i < 3) ? (
                  <span className="name mx-3 px-2">{field.name}</span>
                ) : (
                  <input value={field.name} onChange={(e) => changeRow(i, "name", (val) => (typeof val === 'string'), e.target.value, name, section)} />
                )}
              </div>
              <input className="amount" value={field.amount} onChange={(e) => changeRow(i, "amount", (val) => /^(\d+)?(\.)?(\d+)?$/.test(val), e.target.value, name, section)} onBlur={(e) => e.target.value = parseFloat((e.target.value === "") ? 0 : e.target.value).toFixed(2)} />
              {((name === "grants" && i > 3) || (name === "scholarships" && i > 0) || (name === "loans" && i > 2)) ? <FaTimes style={{ float: "right", marginTop: "5px" }} size={20} onClick={() => delRow(i, name, section)} /> : null}
            </div>
          ))
        }
      </div>
    )
  }


  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Financial Information  {(props.invalid) ? <FaTimes style={{ marginLeft: 'auto', marginTop: "5px", color: "red" }} size={30} /> : null}</Accordion.Header>
        <Accordion.Body>
          <div className="field">
            <h5 className="name">Name</h5>
            <h5 className="amount">Amount</h5>
          </div>
          <hr />
          {financialTable("grants", grants)}
          <hr />
          {financialTable("scholarships", scholarships)}
          <hr />
          {financialTable("loans", loans)}
          <hr />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}